import { render, staticRenderFns } from "./singFont.vue?vue&type=template&id=56496e80&scoped=true&"
import script from "./singFont.vue?vue&type=script&lang=js&"
export * from "./singFont.vue?vue&type=script&lang=js&"
import style0 from "./singFont.vue?vue&type=style&index=0&id=56496e80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56496e80",
  null
  
)

export default component.exports